import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as TripPlanningServices from '../../../../../service/order/tripPlanningServices';
import { ROUTES } from "../../../../../constant/routeConstant";

const useDetailTripPlan = () => {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [outsource, setOutsource] = useState([]);
  const [review, setReview] = useState([]);
  const [whole, setWhole] = useState([]);
  const [owned, setOwned] = useState({});
  const [listDA, setListDA] = useState([]);
  const [pageDA, setPageDA] = useState(1);
  const [limitDA, setLimitDA] = useState(10);
  const [initiateDA, setInitiateDA] = useState({})
  const [pageOrderNotAssign, setPageOrderNotAssign] = useState(1);
  const [limitOrderNotAssign, setLimitOrderNotAssign] = useState(10);
  const [initiateOrderNotAssign, setInitiateOrderNotAssign] = useState({});
  const [listOrderNotAssign, setListOrderNotAssign] = useState([]);
  const [index, setIndex] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [dataNotAssign, setDataNotAssign] = useState({});
  const [skeleton, setSkeleton] = useState(true);
  const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false)
  const [failedModalOpen, setFailedModalOpen] = useState(false)
  const [messages, setMessages] = useState("");
  const [idTripPlan, setIdTripPlan] = useState(null);
  const [isSkeletonListDA, setIsSkeletonListDA] = useState(true);
  const [isSkeletonOrderNotAssign, setIsSkeletonOrderNotAssign] = useState(true);

  const backToList = () => {
    navigate(ROUTES.TRIP_PLANNING.LIST);
  }

  const _getListDA = async (page, limit, id) => {
    const params = { page, limit, filter: `trip_plan_id eq ${id}` }
    const { ok, list, initiate } = await TripPlanningServices.listDA(token, params);
    if (ok && list !== null) {
      setListDA(list);
      setInitiateDA(initiate);
    }
    setIsSkeletonListDA(false)
  }

  const _getListOrderNotAssign = async (page, limit, id) => {
    const params = { page, limit, filter: `trip_plan_id eq ${id}` }
    const { ok, list, initiate } = await TripPlanningServices.listOrderNotAssign(token, params);

    if (ok && list !== null) {
      setListOrderNotAssign(list)
      setInitiateOrderNotAssign(initiate)
    }
    setIsSkeletonOrderNotAssign(false)
  }

  const _getDetailTripPlanning = async () => {
    const { ok, data } = await TripPlanningServices.detailTripPlanning(token, location?.state?.data?.id);
    if (ok) {
      setData(data);
      setReview(data?.review);
      setOutsource(data?.review?.outsource);
      setOwned(data?.review?.owned);
      setWhole(data?.review?.whole);

      if (data?.id) {
        setIdTripPlan(data?.id);
        await _getListDA(pageDA, limitDA, data?.id);
        await _getListOrderNotAssign(pageOrderNotAssign, limitOrderNotAssign, data?.id);
      }
      setSkeleton(false);
    }
  }

  useEffect(() => {
    _getDetailTripPlanning();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (idTripPlan !== null) {
      _getListDA(pageDA, limitDA, idTripPlan);
      _getListOrderNotAssign(pageOrderNotAssign, limitOrderNotAssign, idTripPlan)
    }
  }, [pageDA, limitDA, pageOrderNotAssign, limitOrderNotAssign]);

  // Get Detail Data Not Assign Ketika di klik accordion
  const _getDetailNotAssign = async (id) => {
    const { ok, data } = await TripPlanningServices.detailOrderNotAssign(token, id);
    if (ok && data !== null) {
      setDataNotAssign(data)
    }
  }

  const clickCard = async (i, open, id) => {
    setIndex(i);
    setIsOpen(isOpen ? false : true);
    if (id) {
      await _getDetailNotAssign(id);
    }
  }

  const _btnApproved = async () => {
    const datas = {
      depot_id: data?.depot_id,
      list_trip: [
        {
          id: data?.id,
          updated_at: data?.updated_at
        }
      ]
    }

    const { status, message } = await TripPlanningServices.approve(token, null, datas, null)
    if (status) {
      setMessages(message)
      setSuccessModalOpen(true)
      setStartOpen(false)
    } else {
      setMessages(message)
      setFailedModalOpen(true)
      setStartOpen(false)
    }
  }

  const _btnReject = async () => {
    const datas = {
      depot_id: data?.depot_id,
      list_trip: [
        {
          id: data?.id,
          updated_at: data?.updated_at
        }
      ]
    }

    const { status, message } = await TripPlanningServices.reject(token, null, datas, null);
    if (status) {
      setMessages(message)
      setSuccessModalOpen(true)
      setStartOpen(false)
    } else {
      setMessages(message)
      setFailedModalOpen(true)
      setStartOpen(false)
    }
  }

  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false)
    setStartOpen(false)
    setEndOpen(false)
    setMessages("")
    navigate(ROUTES.TRIP_PLANNING.LIST)
  }

  const _handlePagination = (value, namespace) => {
    switch (namespace) {
      case 'da':
        setIsSkeletonListDA(true)
        setPageDA(value)
        break;
      case 'order_not_assign':
        setIsSkeletonOrderNotAssign(true)
        setPageOrderNotAssign(value)
        break;

      default:
        break;
    }
  }

  const _changeRowPerPage = (value, namespace) => {
    switch (namespace) {
      case 'da':
        setIsSkeletonListDA(true)
        setPageDA(1)
        setLimitDA(value)
        break;
      case 'order_not_assign':
        setIsSkeletonOrderNotAssign(true)
        setPageOrderNotAssign(1)
        setLimitOrderNotAssign(value)
        break;

      default:
        break;
    }
  }

  const _toDetailDA = async (data) => {
    navigate(ROUTES.TRIP_PLANNING.DETAIL2,
      {
        state: {
          dataDA: data,
          data: location?.state?.data
        }
      }
    )
  }

  return {
    data,
    outsource,
    owned,
    review,
    whole,
    listDA,
    listOrderNotAssign,
    skeleton,
    index,
    dataNotAssign,
    startOpen,
    endOpen,
    successModalOpen,
    failedModalOpen,
    messages,
    location,
    isOpen,
    pageDA,
    limitDA,
    initiateDA,
    isSkeletonListDA,
    pageOrderNotAssign,
    limitOrderNotAssign,
    initiateOrderNotAssign,
    isSkeletonOrderNotAssign,
    backToList,
    _toDetailDA,
    clickCard,
    _btnApproved,
    _btnReject,
    setPageDA,
    setLimitDA,
    setEndOpen,
    actModal,
    setStartOpen,
    setFailedModalOpen,
    _handlePagination,
    _changeRowPerPage,
  }
}

export default useDetailTripPlan;